import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { _, TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bl-error-box',
  imports: [CommonModule, IonicModule, SvgIconComponent, TranslateModule],
  template: `
    <ion-card>
      <ion-card-content class="d-flex">
        <svg-icon
          slot="start"
          class="color--primary font--xl"
          key="warning"
          aria-hidden="true"
        ></svg-icon>
        <div class="ml-3">
          <h6 class="text--bold text--base color--dark m-0 mb-1">
            {{ title }}
          </h6>
          <p class="m-0 text--xs">
            {{ content }}
            <br />
            <ion-button
              (click)="retry.emit()"
              class="mt-3"
              color="danger"
              size="small"
            >
              {{ retryText | translate }}
            </ion-button>
          </p>
        </div>
      </ion-card-content>
    </ion-card>
  `,
  styles: `
    :host {
      display: block;

      ion-card {
        box-shadow: none;
        border: 1px solid var(--ion-color-danger-rgba);
        --background: var(--ion-color-danger-light);

        ion-card-content {
          color: rgba(var(--ion-color-dark-rgb), 0.8);
          align-items: flex-start;
          padding: 10px 18px;

          svg-icon {
            min-width: 24px;
          }
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiErrorBoxComponent {
  private translate = inject(TranslateService);
  @Input() title = this.translate.instant(_('COMMON.ERROR_BOX.TITLE'));
  @Input() content = this.translate.instant(_('COMMON.ERROR_BOX.CONTENT'));
  @Input() retryText = this.translate.instant(_('COMMON.ERROR_BOX.RETRY_TEXT'));
  @Output() retry = new EventEmitter<void>();
}
